import ProviderProductTagging from "./ProviderProductTagging";
export default ProviderProductTagging;
